import { ApiErrorProps } from "@wildidea/tools/errors/ApiError/ApiError.js";
import { NotAuthenticatedError as WildNotAuthenticatedError } from "@wildidea/tools/errors/ApiError/NotAuthenticatedError.js";
import { Duration } from "@wildidea/tools/utils/Duration.js";

import { WithUserId } from "./User.js";

export interface LoginInput extends WithLoginIdentifier {
  password: string;
}

export interface WithLoginIdentifier {
  /** May be: `userId`, `email`, `handle` */
  identifier: string;
}

export interface WithRefreshToken {
  refreshToken: string;
}

export interface UserSignInAttributes {
  userId: string;
  email: string;
  handle: string;
}

export interface UpdateUserPasswordInput extends WithUserId {
  newPassword: string;
  oldPassword: string;
}

export interface Tokens {
  accessToken: string;
  idToken: string;
  refreshToken: string;
  expires: Duration;
}

export interface LoginResponse {
  /** Seconds */
  expires: number;
}

export enum TokenError {
  Missing = "Missing",
  Invalid = "Invalid",
  Expired = "Expired",
  Revoked = "Revoked",
}
export class NotAuthenticatedError extends WildNotAuthenticatedError<{
  tokenError: TokenError;
}> {
  constructor({
    tokenError,
    ...params
  }: Omit<
    ApiErrorProps<"NotAuthenticatedError">,
    "code" | "detail" | "reason"
  > & {
    tokenError: TokenError;
    cause?: unknown;
  }) {
    super({
      ...params,
      reason:
        tokenError === TokenError.Expired
          ? "Your session has expired."
          : tokenError === TokenError.Revoked
            ? "You have been logged-out."
            : "You are not logged in.",
      detail: { tokenError },
    });
  }
}
